"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TenantTagFormModule = /** @class */ (function () {
    function TenantTagFormModule() {
    }
    return TenantTagFormModule;
}());
exports.TenantTagFormModule = TenantTagFormModule;
